import SyosController from './SyosController';
import SyosGlobalConfig from './SyosGlobalConfig';

window.tnew.syos = {
  SyosController,
  config: SyosGlobalConfig,
};



// WEBPACK FOOTER //
// ./V7/syos/syos.js